import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Paymentfailure from './Paymentfailure';
import PaymentSuccessActivity from '../ActivitiesWidget/PaymentSuccessActivity';
import FeedbackComponent from '../feedbackWidget/FeedbackComponent';
import CancelReservation from './CancelReservation';
import { Box, Typography } from '@mui/material';
import { tekst as jmTekst, vertaal as jmVertaal } from "../../lib/woorden";
const ConditionalRedirect = () => {
  const location = useLocation();  // Get the current location (URL)
  const navigate = useNavigate();  // Use the navigate hook for programmatic navigation
    const queryParams = new URLSearchParams(location.search);
    const secretkey = queryParams.get('secretkey');
    const key = queryParams.get('key');
    // Ook restype in kleine letters: zo stond het tot 14-10-2026 in de enquêtelink van horeca, en dan opende de enquête nooit.
    const restype=queryParams.get('resType') ?? queryParams.get('restype')
    if(secretkey && restype == 'feedback'){
      return <FeedbackComponent />
    }
    if ((secretkey || key) && restype != 'cancel') {
        return <PaymentSuccessActivity />
       } // Redirect to PaymentSuccessActivity
       else {
       return(
       <Box
       sx={{
         height: "100vh",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         background: "#f9fafb",
         flexDirection: "column",
         textAlign: "center",
         p: 3,
       }}
     >
       <Typography
         sx={{
           fontSize: { xs: "24px", md: "32px" },
           fontWeight: 600,
           color: "#262626",
           mb: 1,
         }}
       >
         {jmVertaal("No Widget Found")}
       </Typography>
 
       <Typography
         sx={{
           color: "#6b7280",
           fontSize: { xs: "14px", md: "16px" },
           mb: 3,
           maxWidth: "420px",
         }}
       >
         The widget you are trying to access is not available or the link might
         be invalid.
       </Typography>
     </Box>
       )
      }
};
export default ConditionalRedirect;
